<template>
  <div class="admin-menus">
    <header-title title="Cartas"></header-title>
    <div class="product-btn">
      <v-btn
        dense
        outlined
        @click="openMenuDialog('addMenu')"
        :style="adminNavigationBackTheme"
      >
        + Nueva
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            outlined
            dense
            label="Buscar"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="menus"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.menu_image`]="{ item }">
            <div v-if="isHomeVersionPremium" class="menu-image">
              <img
                v-if="item.menu_image"
                :src="showImageOrFallbackImage(item.menu_image)"
                @error="item.menu_image = fallbackImage"
                :alt="item.menu_image"
              />
              <img v-else :src="fallbackImage" :alt="item.name" />
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template v-slot:[`item.active`]="{ item }">
            <div style="display:flex;">
              <v-switch
                v-model="item.active"
                @change="updateActive($event, item)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openMenuDialog(item.id)">
              mdi-pencil
            </v-icon>
          </template>
          <template v-slot:[`item.deleteAction`]="{ item }">
            <v-btn icon :disabled="item.active">
              <v-icon class="mr-2" @click="deleteCartasDialog(item.id)">
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <MenusDialog ref="menuDialog"></MenusDialog>

    <v-row justify="center">
      <DeleteCartasDialog
        :dialog="dialog"
        @cancel="deleteCancel"
        @deleteCartas="deleteCartas"
      ></DeleteCartasDialog>
    </v-row>
  </div>
</template>

<script>
import MenusDialog from "../../../components/admin/menus/MenusDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import DeleteCartasDialog from "@/components/admin/menus/DeleteCartasDialog";
import { MenusTableHeader } from "@/utils/tableHeaderconstants";
import { saveUiMenuOrder, deleteUiMenuOrder } from "@/collections/uiMenuOrder";
import { deleteScheduleByMenu } from "@/collections/scheduleByMenu";
import { menusCollection, deleteMenu, updateMenu } from "@/collections/menus";

export default {
  name: "Menus",
  components: {
    MenusDialog,
    HeaderTitle,
    DeleteCartasDialog
  },
  data() {
    return {
      search: "",
      headers: [...MenusTableHeader],
      menus: [],
      dialog: false
    };
  },
  firestore() {
    return {
      menus: menusCollection
    };
  },
  methods: {
    async updateActive(value, menu) {
      try {
        await updateMenu(menu.id, { active: value });
        await saveUiMenuOrder(menu.id, {
          ...menu,
          id: menu.id,
          type: "menus",
          sort: 1000
        });
      } catch (error) {
        this.setlogError(
          "save_ui_menu_order/update_menu",
          "Obtained error message in updateActive()",
          error.stack,
          this.$options.name
        );
      }
    },
    openMenuDialog(id) {
      this.$refs.menuDialog.open(id);
    },
    async deleteCartas() {
      try {
        await deleteUiMenuOrder(this.selectedCartasId);
        await deleteScheduleByMenu(this.selectedCartasId);
        await deleteMenu(this.selectedCartasId);
        this.selectedCartasId = null;
        this.dialog = false;
      } catch (error) {
        this.setlogError(
          "delete/schedule_by_menu/ui_menu_order/menu",
          "Obtained error message in deleteCartas()",
          error.stack,
          this.$options.name
        );
      }
    },
    deleteCartasDialog(id) {
      this.selectedCartasId = id;
      this.dialog = true;
    },
    deleteCancel() {
      this.dialog = false;
    }
  }
};
</script>

<style>
.menu-image {
  width: 60px;
  height: 60px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
}
.menu-image img {
  max-width: 100%;
  max-height: 80px;
}
</style>
